// src/pages/SettingsPage/components/AddWorkspaceModal.tsx
import {
  Box,
  Button,
  Modal,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import * as R from "ramda";
import React, { useState } from "react";
import { WorkspaceFormData } from "./types/settings.types";

export const AddWorkspaceModal: React.FC<{
  setFormData: (setFormData: WorkspaceFormData) => any;
  formData: WorkspaceFormData;
  modalOpen: boolean;
  setModelOpen: (isOpen: boolean) => any;
  onSubmit: (config: { formData: WorkspaceFormData }) => any;
}> = ({ setFormData, formData, modalOpen, setModelOpen, onSubmit }) => {
  const [formErrors, setFormErrors] = useState<string[]>([]);

  const validateForm = () => {
    const emailFormErrors = formData.ownerEmail ? [] : ["ownerEmail"];
    const appNameFormErrors = formData.appName ? [] : ["appName"];
    const ownerNameFormErrors = formData.ownerName ? [] : ["ownerName"];
    const formErrors = [
      ...emailFormErrors,
      ...appNameFormErrors,
      ...ownerNameFormErrors,
    ];
    setFormErrors(formErrors);
    return formErrors.length === 0;
  };

  const setFormField = (key: keyof WorkspaceFormData, value: string) => {
    setFormData({ ...formData, [key]: value });
  };

  return (
    <Modal open={modalOpen}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
        }}
      >
        <Paper
          elevation={7}
          sx={{
            padding: "2rem",
            width: "40rem",
            gap: 2,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Typography variant="h6">Add New Workspace</Typography>
          <TextField
            value={formData.ownerEmail}
            label="Owner Email"
            placeholder="johndoe@gmail.com"
            error={R.includes("ownerEmail", formErrors)}
            helperText={
              R.includes("ownerEmail", formErrors) ? "Required" : undefined
            }
            onChange={(e) => setFormField("ownerEmail", e.target.value)}
          />
          <TextField
            value={formData.ownerName}
            label="Owner Name"
            placeholder="John Doe"
            error={R.includes("ownerName", formErrors)}
            helperText={
              R.includes("ownerName", formErrors) ? "Required" : undefined
            }
            onChange={(e) => setFormField("ownerName", e.target.value)}
          />
          <TextField
            value={formData.appName}
            label="Workspace Name"
            placeholder="My Workspace"
            error={R.includes("appName", formErrors)}
            helperText={
              R.includes("appName", formErrors) ? "Required" : undefined
            }
            onChange={(e) => setFormField("appName", e.target.value)}
          />
          <Box>
            <Button
              onClick={() => {
                if (!validateForm()) return;
                onSubmit({ formData });
                setModelOpen(false);
              }}
            >
              Add
            </Button>
            <Button onClick={() => setModelOpen(false)}>Cancel</Button>
          </Box>
        </Paper>
      </Box>
    </Modal>
  );
};
